// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/quote/index.scss
// module id = 254
// module chunks = 0